import { TableWithStoredSettingsAndLayoutSettings } from '@Components/Tables/TableWithStoredSettingsAndLayoutSettings';
import { STAMMDATEN_API } from '@Constants/backendConstants';
import { avvColumns } from '@Constants/TableColumns';
import { useHasSystemAccess } from '@Contexts/session/useHasSystemAccess';
import type { ApiAvv } from '@Model';
import { EnumFrontendLayoutSetting } from '@Model';
import { useListApi } from '@Hooks/useListApi';
import { AvvRepository } from '@Repositories/Stammdaten';

export function FrameListAvv() {
    const module = useListApi(AvvRepository, STAMMDATEN_API);
    const hasSystemAccess = useHasSystemAccess();

    return (
        <TableWithStoredSettingsAndLayoutSettings<ApiAvv>
            layoutSettingsContext={EnumFrontendLayoutSetting.AvvsTableLayout}
            name="AvvList"
            columns={avvColumns}
            loader={module.loadPage}
            canCreate={hasSystemAccess}
            useOnClickNavigation
            fullSize
        />
    );
}
